import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Validate
} from "../data/login/loginActions";

const mapStateToProps = (state) => ({
  error: state.loginReducer.error,
});

const mapDispatchToProps = (dispatch) => ({
  Validate: (username,pass) => dispatch(Validate(username, pass)),
});

export const Container = (Component) => withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component));

export default Container;
